import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.234 9.352V7.123A4.724 4.724 0 0 0 11.51 2.4a4.72 4.72 0 0 0-4.743 4.703v2.249",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.466 21.6h-7.93A3.935 3.935 0 0 1 3.6 17.665v-4.452a3.935 3.935 0 0 1 3.935-3.935h7.93a3.935 3.935 0 0 1 3.936 3.935v4.452a3.935 3.935 0 0 1-3.935 3.935",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.5 14.287v2.305",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }